"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCreditCardOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27 6H5a3 3 0 00-3 3v14a3 3 0 003 3h22a3 3 0 003-3V9a3 3 0 00-3-3zM5 8h22a1 1 0 011 1v2H4V9a1 1 0 011-1zm22 16H5a1 1 0 01-1-1V13h24v10a1 1 0 01-1 1z" }),
        React.createElement("path", { d: "M7 19h7v2H7z" })));
}
exports.default = SvgCreditCardOutline;
//# sourceMappingURL=CreditCardOutline.js.map